import { Console } from 'console';
import { FoodcourtmenuService } from 'src/app/services/foodcourtmenu.service';
import { DatePipe } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbDate, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { ExcelDataProvider } from 'src/app/_Core/_Providers/excel.provider';
// import { DateService } from 'src/app/_Core/_Services/date.service';
// import { AppStateProvider } from 'src/app/_Core/_Providers/app-state.provider';
import { AppStateProvider } from 'src/app/services/app-state.provider';

@Component({
  standalone: false,
  selector: 'app-bulk-upload-preview-food-menu',
  templateUrl: './bulk-upload-preview-food-menu.component.html',
  styleUrls: ['./bulk-upload-preview-food-menu.component.scss']
})
export class BulkUploadPreviewFoodMenuComponent implements OnInit, OnDestroy {
  name: boolean;
  fieldErrors: any[];
  mobile: any;
  email: any;
  guestName: any;
  guestMobile: boolean;
  guestEmail: any;
  vehicleNumber: any;
  vehicleType: any;
  floor: any;
  buildingName: any;
  formatDate: string;
  buildingTitle: string = '';
  amorpm: boolean = false;
  amorpm1: boolean = false;
  normalizeTime: any;
  remarks: string = '';
  startTimePlaceholder: string = '';
  endTimePlaceholder: string = '';
  buildingProperty: any = [];
  floorProperty: any = [];
  floorTitle: any;
  tableHeaders: any[] = [];
  tableBody: any = [];
  selectAll: boolean = false;
  popover: any = null;
  meridian: boolean = true;
  startTime = { hour: 7, minute: 0 };

  data: any;
  fullname: string;
  mobileNumber: any;
  emailId: string;
  myCompanyData: any;
  buildingId: any;
  guestList: any;
  floorCount: any;
  floorList: any;
  vehicleTypeList: any;
  meetingPurposeData: any;
  tempMeetingPurposeData: any;
  meetingPurpose: any;
  t0600Vmsguests: any = [];
  allVegitationData: any = [];
  vegetationNotes: any = [];
  mdate: any;
  selectedDate: any;
  userId: any;
  mend: any;
  tempTime: any;
  tempEndTime: any;
  id: any;
  tempGuestList: any = [];
  showError: boolean;
  errName: any;
  errfloor: any;
  sDate: any;
  minDate = undefined;
  fDate: any;
  time1: any;
  time2: any;
  validationError: any[];
  isValid: any[];
  isValidtRow: any[];
  totalInValidRows: number;
  totalValidRows: number;
  data2: any;
  isOperationCompleted: boolean;
  tempHeaders: any[];
  validationEr: boolean;
  errDate: any;
  basementCount: any;
  vendorId: any;
  allMenuData: any = [];
  isMenuAvailable: any;

  constructor(
    private router: Router,
    // private dateSrv: DateService,
    public datepipe: DatePipe,
    private ngbDatepickerConfig: NgbDatepickerConfig,
    private excelProvider: ExcelDataProvider,
    private activatedRoute: ActivatedRoute,
    private foodcourtmenuService: FoodcourtmenuService,
    private appStateSrv: AppStateProvider,
    private route: ActivatedRoute,
  ) {
    const current = new Date();
    ngbDatepickerConfig.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate(),
    };

    ngbDatepickerConfig.outsideDays = 'hidden';
  }

  ngOnInit(): void {

    this.route.params.subscribe((params) => {
      this.vendorId = params['id'];
    });

    this.activatedRoute.queryParams.subscribe(res => {
      this.id = res.id ? res.id : null
    })

    this.data = this.foodcourtmenuService.getExcelData();
    if (this.data != null) {
      // this.processApiResponse(JSON.parse(this.data).map(obj => ({ ...obj, validationIssues: true, isValid: true, isValidRow: true })));
      this.processApiResponse(JSON.parse(this.data).map(obj => ({ ...obj })));
    }

    const jsDate = new Date();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavLand');

    // this.subscriptions.unsubscribe();
  }

  convertFormat(y, m, d) {
    return y + '-' + m + '-' + d;
  }

  onClickedOutside(e: Event) {
    // console.log('Clicked outside:', e);
  }

  openPopover(popover) {
    this.popover = popover
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  bulkInvite(data) {
    var files = data.target.files; // FileList object
    var xl2json = new this.excelProvider.ExcelToJSON();
    xl2json.parseExcel(files[0]).then(data => {
      // this.processApiResponse(JSON.parse(data).map(obj => ({ ...obj, validationIssues: true, isValid: true, isValidRow: true })));
      this.processApiResponse(JSON.parse(data).map(obj => ({ ...obj })));
    }).catch(err => {
    });
  }

  prepareTableData(tableData) {

    this.tableBody = [];
    this.tableHeaders = [];
    // this.tableBody = tableData
    let sampleheaders = [];

    for (let header of tableData)
      sampleheaders.push(...Object.keys(header));

    this.tableHeaders = [...new Set(sampleheaders)];

    for (let body of tableData) {
      let temp = [];
      for (let head of this.tableHeaders) {
        temp.push(body[head] == undefined ? '' : body[head])
      }
      this.tableBody.push(temp);
      console.log(this.tableBody);
      this.guestList = this.tableBody

    }
  }

  selectAllHandler() {
    if (this.selectAll) { }
  }

  selectedGuest(guestData, index) {

  }
  deleteAllInvites() {
    if (this.selectAll) {
      this.tableBody = [];
      this.tableHeaders = [];
    }
  }

  generateUniqueId(i, type) {
    return i + '__' + type;
  }

  checkIfSelected(id: string) {
    const ele = document.getElementById(id) as HTMLInputElement;
    return !ele.checked ? 'disabledClick' : ''
  }

  deleteSelected(inviteData, i) {
    console.log(inviteData)
    if (this.checkIfSelected(i + '__th') !== 'disabledClick')
      this.tableBody.splice(i, 1)

    this.processApiResponse(this.reprepareData(this.tableBody, this.tableHeaders))
    // this.bulkInviteValidation(this.tableBody)
  }

  reprepareData(tb, th) {

    var finalB = []
    tb.forEach(res => {
      let bdata = {};
      res.forEach((tb, bodyIndex) => {
        //console.log(body);
        th.forEach((head, headIndex) => {
          // console.log(head)
          if (bodyIndex == headIndex) {
            bdata[head] = tb
          }
        })

      })
      // console.log(bdata);
      finalB.push(bdata)

    })

    return finalB
  }

  toggleMeridian() {
    this.meridian = !this.meridian;
  }

  editSelected(from, to, i, type) {

    if (this.checkIfSelected(i + '__th') !== 'disabledClick') {
      if (document.getElementById(i + '__edit').style.display == 'block') {
        document.getElementById(i + '__edit').style.display = 'none';
        document.getElementById(i + '__save').style.display = 'block'
      } else {
        document.getElementById(i + '__edit').style.display = 'block';
        document.getElementById(i + '__save').style.display = 'none'
      }

      let fromEle = document.getElementsByClassName(from);
      let toEle = document.getElementsByClassName(to);

      for (let el of Object.keys(fromEle))
        if (document.getElementsByClassName(from)[el].style.display == 'block')
          document.getElementsByClassName(from)[el].style.display = 'none';
        else
          document.getElementsByClassName(from)[el].style.display = 'block';

      for (let el of Object.keys(toEle))
        if (document.getElementsByClassName(to)[el].style.display == 'block')
          document.getElementsByClassName(to)[el].style.display = 'none';
        else
          document.getElementsByClassName(to)[el].style.display = 'block';

      if (type == 'save') {
        let _t = [];
        for (let el of Object.keys(toEle)) {
          _t.push(document.getElementsByClassName(to)[el].value);

        }
        _t.push(true, true, true);
        this.tableBody.splice(i, 1, _t);
        this.processApiResponse(this.reprepareData(this.tableBody, this.tableHeaders))
      }

    }
  }

  send() {

    this.allMenuData = [];

    for (let i = 0; i < this.guestList.length; i++) {
      this.allMenuData.push({
        FoodName: this.guestList[i][0],
        FoodType: this.guestList[i][1],
        FoodCuisine: this.guestList[i][2],
        FoodPrice: String(this.guestList[i][3]),
        FoodDescription: this.guestList[i][4],
        IsAvailable: true,
      });
    }

    const data = {
      FoodCourtVendorId: this.vendorId,
      CreatedBy: localStorage.getItem('claAdminId'),
      IsActive: true,
      FoodCourtVendorMenuBulkUploadList: this.allMenuData,
    };

    this.foodcourtmenuService.createBulkUploadFoodMenu(data).subscribe((res: any) => {
      if (res?.isValid == true) {
        this.router.navigate(['/list-food-menu/' + this.vendorId]);
      }
    });
  }


  validation(validate) {
    this.showError = false;
    this.errName = validate.form.controls.building?.status;
    this.errDate = validate.form.controls.fdate?.status
    if (this.errName == 'INVALID' || this.errDate == 'INVALID')
      this.showError = true;

  }

  processApiResponse(data) {

    if (data.length > 200) {
      this.appStateSrv.showToast('Vegitation list cannot exceed 200');
      return;
    }

    console.log("processAPI res", data)

    this.bulkInviteValidation(data);

    if (data != null) {

      this.validationError = [];
      this.isValid = [];
      this.isValidtRow = [];
      data.map(result => {
        this.validationError.push(result.validationIssues)
        this.isValid.push(result.isValid)
        this.isValidtRow.push(result.isValidRow)
      });
      this.prepareTableData(data)
      this.totalInValidRows = 0;
      this.totalValidRows = 0;
      for (let rowEmp of this.isValidtRow) {
        if (rowEmp == false)
          this.totalInValidRows++;
        else
          this.totalValidRows++;
      }
    }
  }

  bulkInviteValidation(data) {
    console.log(data)
    console.log(JSON.parse(JSON.stringify(data).replace(/\s/g, "").replace(/\./g, "")))

    this.validationEr = false;

    JSON.parse(JSON.stringify(data).replace(/\s/g, "")).forEach((res, i) => {
    });

    JSON.parse(JSON.stringify(data).replace(/\s/g, "").replace(/\./g, "")).forEach((res, i) => {

      console.log(res);

      if (res.FoodName == undefined || res.FoodName.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.FoodType == undefined || res.FoodType.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.FoodCuisine == undefined || res.FoodCuisine.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.FoodPrice == undefined || res.FoodPrice.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.FoodDescription == undefined || res.FoodDescription.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      // if (res.MenuAvailability == undefined || res.MenuAvailability.length == 0) {
      //   data[i].isValid = false
      //   data[i].isValidRow = false;
      //   data[i].validationIssues = false;
      //   this.validationEr = true;
      // }
    });
  }

  updateTable(data) {
    this.processApiResponse(this.reprepareData(this.tableBody, this.tableHeaders))
  }

}

